// extracted by mini-css-extract-plugin
export default {"AvatarStack":"assignee-stack-module__AvatarStack--nD9b2"};